__turbopack_context__.v({
  "body": "ArticleBody-module__kHggQq__body",
  "callout": "ArticleBody-module__kHggQq__callout",
  "calloutArrow": "ArticleBody-module__kHggQq__calloutArrow",
  "calloutLink": "ArticleBody-module__kHggQq__calloutLink",
  "calloutText": "ArticleBody-module__kHggQq__calloutText",
  "calloutTitle": "ArticleBody-module__kHggQq__calloutTitle",
  "compare": "ArticleBody-module__kHggQq__compare",
  "compareBad": "ArticleBody-module__kHggQq__compareBad",
  "compareCol": "ArticleBody-module__kHggQq__compareCol",
  "compareGood": "ArticleBody-module__kHggQq__compareGood",
  "compareList": "ArticleBody-module__kHggQq__compareList",
  "compareTitle": "ArticleBody-module__kHggQq__compareTitle",
  "h2": "ArticleBody-module__kHggQq__h2",
  "h3": "ArticleBody-module__kHggQq__h3",
  "lead": "ArticleBody-module__kHggQq__lead",
  "list": "ArticleBody-module__kHggQq__list",
  "paragraph": "ArticleBody-module__kHggQq__paragraph",
  "table": "ArticleBody-module__kHggQq__table",
  "tableWrap": "ArticleBody-module__kHggQq__tableWrap",
  "tool": "ArticleBody-module__kHggQq__tool",
  "toolDesc": "ArticleBody-module__kHggQq__toolDesc",
  "toolHead": "ArticleBody-module__kHggQq__toolHead",
  "toolLimit": "ArticleBody-module__kHggQq__toolLimit",
  "toolName": "ArticleBody-module__kHggQq__toolName",
  "toolTag": "ArticleBody-module__kHggQq__toolTag",
});
